// Action constants need to be in a separate file from rootReducer to break import dependency cycle

export const CLEAR_SCENE = 'CLEAR_SCENE';
